import React from 'react';
import Header from '../../Universal/Header';
import Footer from '../../Universal/Footer';
import './Policies.css';

const CancellationPolicy = () => {
    return (
        <div className="policy-page-header policy-page-wrapper">
            <Header />

            <div className="policy-hero">
                <div className="policy-hero-content">
                    <h1 className="policy-title">Cancellation Policy</h1>
                    <p className="policy-intro">Guidelines for cancellations.</p>
                </div>
            </div>

            <section className="policy-container">
                <div className="policy-content-wrapper">
                    <div className="policy-main-text">
                        <h3>Event & Membership Cancellation</h3>
                        <ol>
                            <li>Members may request cancellation of event participation by notifying the Club in advance.</li>
                            <li>Cancellation of membership is allowed; however, membership fees are non-refundable.</li>
                            <li>In case an event is cancelled by the Club, eligible refunds (if applicable) will be processed as per the Refund Policy.</li>
                        </ol>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default CancellationPolicy;
